module.exports = __webpack_public_path__ + "static/media/girl-tree.a1a1deae.png";